<template>
  <div class="dashboard">
    <!-- Background elements -->
    <transition name="fade">
      <div v-if="current_step == 1">
        <img id="bg5" src="../assets/bg5.svg"/>
        <img id="bg6" src="../assets/bg6.svg"/>
        <img id="bg7" src="../assets/bg7.svg"/>
        <img id="bg8" src="../assets/bg8.svg"/>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="current_step == 2">
        <img id="bg9" src="../assets/bg9.svg"/>
        <img id="bg10" src="../assets/bg10.svg"/>
        <img id="bg11" src="../assets/bg11.svg"/>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="current_step == 3">
        <img id="bg12" src="../assets/bg12.svg"/>
        <img id="bg13" src="../assets/bg13.svg"/>
        <img v-if="issue && friend.name && friend.age && friend.city && !send_method" id="bg14" src="../assets/bg14.svg"/>
      </div>
    </transition>
    <v-content>
        <v-container fluid>

          <div class="main-container">

            <div class="send-progress">
              <div class="progress-flex">
                <div v-bind:class="{ active: current_step == 1 || current_step == 2 || current_step == 3 }"></div>
                <div v-bind:class="{ active: current_step == 2 || current_step == 3 }"></div>
                <div v-bind:class="{ active: current_step == 3 }"></div>
              </div>
            </div>


              <div v-if="current_step == 1" class="question-wrapper">

              <p class="question">What’s your friend’s/loved one’s <span class="selection-pink">name/nickname?</span></p>
              <v-text-field id="exampleInput2"
                            class="boxed-input"
                            v-model="friend.name"
                            required
                            append-icon="person"
                            label=""
                            color="#222"
                            outlined
                            flat
                            @change="generateMessage">
              </v-text-field>

              <p class="question" v-html="label_issue"></p>
              <v-autocomplete
                            v-model="issue"
                            class="boxed-input"
                            v-if="!custom"
                            :items="issue_options"
                            item-text="text"
                            item-value="value"
                            label=""
                            return-object
                            color="#222"
                            outlined
                            flat
                            @change="generateMessage"
              >
                <template v-slot:no-data>
                  <v-list-tile v-if='!custom'
                    ripple
                    @click="custom = true"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>Concern not listed?</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-autocomplete>

              <v-text-field id="custom-concern-input"
                            class="boxed-input"
                            v-model="issue_custom"
                            v-if="custom"
                            required
                            label="Describe the concern you'd like to add"
                            color="#2a7d35"
                            solo
                            outlined
                            flat
                            @change="generateMessage">
              </v-text-field>
              <p id="note-issue">(Choose or type)<p>

              <!-- <p v-if="!custom" class="not-listed-btn" id="not-listed-btn" @click="custom = true">Concern not listed?</p> -->
              <p v-if="custom" class="not-listed-btn" id="listed-btn" @click="custom = false">Select existing concern</p>

              <router-link v-if="!custom" class="next-btn" :to="{ name: 'send', params: { step: 2 }}">Next</router-link>
              <router-link v-if="custom" class="next-btn" :to="{ name: 'send', params: { step: 3 }}">Next</router-link>
            </div>

              <transition name="fade">
                <div v-if="current_step == 2" class="question-wrapper">

              <p class="question" v-html="label_city"></p>
              <v-text-field id="friends-city-input"
                            v-model="friend.city"
                            required
                            v-if="!custom"
                            append-icon="location_city"
                            label=""
                            color="#222"
                            outlined
                            flat
                            @change="generateMessage">
              </v-text-field>

              <p class="question" v-html="label_age"></p>
              <v-select id="friends-age-input"
                            :items="age_options"
                            required
                            v-if="!custom"
                            v-model="friend.age"
                            label=""
                            color="#222"
                            outlined
                            flat
                            @change="generateMessage">
              </v-select>
              <router-link class="next-btn" :to="{ name: 'send', params: { step: 3 }}">Next</router-link>
            </div>
              </transition>

              <div v-if="current_step == 3" class="question-wrapper">

              <p v-if="!custom" class="question">How would you like us <span class="selection-pink">to deliver</span> the message?</p>
              <p v-if="custom" class="question">We will review your submission <span class="selection-pink">in the next 48hr</span></p>
              <v-radio-group id="radio-btn-wrapper" row v-model="send_method" v-if="!custom" :mandatory="false">
                 <v-radio id="radio-btn-1" label="Email" value="email" color="secondary"></v-radio>
                 <v-radio id="radio-btn-2" label="Text message" value="text" color="secondary"></v-radio>
              </v-radio-group>

               <v-text-field v-if="send_method === 'email'" id="friends-email-input"
                             v-model="friend.email"
                             required
                             prepend-icon="alternate_email"
                             :label=label_email
                             color="#EC4F7F"
                             @change="generateMessage">
               </v-text-field>

               <v-text-field v-if="send_method === 'text'" id="friends-phone-text-input"
                             v-model="friend.phone_text"
                             required
                             prepend-icon="phone"
                             mask="phone"
                             :label=label_phone_full
                             color="#EC4F7F"
                             @change="generateMessage">
               </v-text-field>

               <v-text-field v-if="custom" id="user-email-input"
                             v-model="user_email"
                             required
                             prepend-icon="alternate_email"
                             label="Enter your email address"
                             color="#EC4F7F"
                             @change="generateMessage">
               </v-text-field>

              </br>
              <p id="message" v-if="issue && friend.name && friend.age && friend.city && send_method">Dear {{this.friend.name}}, {{this.message}}</p>

              <a class="next-btn" v-if="!custom" @click="sendMethod()" :disabled="send_button" variant="secondary">Send</a>
              <a class="next-btn" v-if="custom" @click="sendForReview()" :disabled="!user_email" variant="secondary">Send for review</a>

              <v-progress-circular
               v-if="showProgress"
               id="progress-circle"
               :size="70"
               :width="7"
               color="#F65996"
               indeterminate
              ></v-progress-circular>
            </div>

          <!-- <video controls id="yt-player" src="../assets/video.mp4"></video> -->

        </div>
      </v-container>
    </v-content>

  </div>
</template>

<script>
import IssuesData from '../data.js';
import autocomplete from './autocomplete.vue';
import firebase from 'firebase'

export default {
  name: 'Dashboard',
  props: {

  },
  components: {
    autocomplete
  },
  data () {
    return {
      issue: null,
      friend: {
        name: null,
        email: null,
        age: null,
        phone: null,
        city: null,
        phone_text: null
      },
      issue_options: [],
      age_options: [],
      message: null,
      send_method: null,
      custom: false,
      issue_custom: null,
      user_email: null,
      showProgress: false
    }
  },
  computed: {
    current_step: function () {
      return this.$route.params.step;
    },
    send_button: function () {
      if (this.issue && this.friend.name && this.friend.age && this.friend.city && this.send_method) {
        if (this.send_method === 'text') {
          if (this.friend.phone_text) {
            return false
          }
          else {
            return true
          }
        } else {
          return false
        }
      } else {
        return true
      }
    },
    label_issue: function () {
      if (this.friend.name) {
        return 'What issue would you like to share with <span class="selection-pink">' + this.friend.name + '</span>?'
      } else {
        return `Select a <span class="selection-pink">concern</span>`
      }
    },
    label_email: function () {
      if (this.friend.name) {
        return "What is " + this.friend.name + "'s email address?"
      } else {
        return 'Enter email address'
      }
    },
    label_phone: function () {
      if (this.friend.name) {
        return "What are the last 4 digits of " + this.friend.name + "'s phone number?"
      } else {
        return 'What are the last 4 digits of her/his phone number?'
      }
    },
    label_city: function () {
      if (this.friend.name) {
        return '<span class="selection-pink">What city</span> does ' + this.friend.name + ' live in?'
      } else {
        return '<span class="selection-pink">What city</span> does she/he live in?'
      }
    },
    label_age: function () {
      if (this.friend.name) {
        return '<span class="selection-pink">How old is ' + this.friend.name + '?'
      } else {
        return '<span class="selection-pink">How old</span> is she/he?'
      }
    },
    label_phone_full: function () {
      if (this.friend.name) {
        return "What is " + this.friend.name + "'s full phone number?"
      } else {
        return "What is your friend's full phone number?"
      }
    },

  },
  methods: {
    sendMethod() {
        ga('send', 'event', { eventCategory: 'general', eventAction: 'click', eventLabel: 'message_sent', eventValue: 1});
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.location = url;
          }
        };
        gtag('event', 'conversion', {
            'send_to': 'AW-710014455/zyB4CI_VyqoBEPfrx9IC',
            'event_callback': callback
        });

        if (this.send_method === 'email') {
          this.sendEmail();
        } else if (this.send_method === 'text') {
          if (this.friend.phone_text) {
            this.sendText();
          } else {
            alert('Enter the phone number!');
          }
        }
    },
    sendEmail() {
      let self = this;
      var params = {};
      params['friends_name']=this.friend.name;
      params['friends_email']=this.friend.email;
      params['issue']=this.issue;
      params['message']=this.message;
      params['friends_age']=this.friend.age;
      params['friends_phone']=this.friend.phone;
      params['friends_city']=this.friend.city;

      // Change to your service ID, or keep using the default service
      var service_id = "default_service";

      var template_id = "template_Pu4fURZB";
      this.showProgress = true;
      emailjs.send(service_id, template_id, params)
        .then(function(){
           self.$router.push('/success');
         }, function(err) {
           alert("Send email failed!\r\n Response:\n " + JSON.stringify(err));
        });

      return false;
    },
    sendText() {
      let self = this;
      var addMessage = firebase.functions().httpsCallable('sendText');
      this.showProgress = true;
      addMessage({text: 'Dear ' + this.friend.name + ', ' + this.message, number: this.friend.phone_text}).then(function(result) {
        // // Read result of the Cloud Function.
        // var sanitizedMessage = result.data.text;
        self.$router.push('/success');
        this.friend.name = null;
        this.friend.email = null;
        this.issue = null;
        this.message = null;
        this.friend.age = null;
        this.friend.phone = null;
        this.friend.city = null;
      }).catch(function(error) {
        // Getting the Error details.
        self.$router.push('/success');
        var code = error.code;
        var message = error.message;
        var details = error.details;
        console.log(code + ' ' + message + ' ' + details);
      });
    },
    generateMessage() {
      console.log(this.issue)
      this.message = "If you are in your " + this.friend.age + " and you live in " + this.friend.city + ", then we have a private message from someone who knows you and wants to help. " + IssuesData.ISSUE_MESSAGES[this.issue.value] + "They felt uncomfortable letting you know directly and instead decided to use hard2say to deliver this message. Their only intention is to help and they wish you well.";
    },
    onClickChild (value) {
      console.log(value) // someValue
    },
    sendForReview() {
      var params = {};
      let self = this;
      params['issue_custom']=this.issue_custom;
      params['user_email']=this.user_email;
      this.showProgress = true;

      // Change to your service ID, or keep using the default service
      var service_id = "default_service";

      var template_id = "issue_for_review";
      emailjs.send(service_id, template_id, params)
        .then(function(){
           self.$router.push('/success');
         }, function(err) {
           alert("Submission failed!\r\n Response:\n " + JSON.stringify(err));
        });

      return false;
    }
  },
  mounted() {
    for (let i=0; i<IssuesData.ISSUES.length; i++) {
      let option = {};
      option['value'] = i;
      option['text'] = IssuesData.ISSUES[i];
      this.issue_options.push(option);
    }
    for (let i=0; i<IssuesData.AGE_OPTIONS.length; i++) {
      let option = {};
      option['value'] = IssuesData.AGE_OPTIONS[i];
      option['text'] = IssuesData.AGE_OPTIONS[i];
      this.age_options.push(option);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#bg5 {
    position: absolute;
    top: 0;
    left: 0;
    animation: float-y-1 10s infinite;
}
#bg6 {
    position: absolute;
    top: 30%;
    left: 0;
    animation-delay: 0.25s;
    animation: float-x-1 8s infinite;
}
#bg7 {
    position: absolute;
    bottom: 0;
    left: 0;
    animation-delay: 0.6s;
    animation: float-y-2 9s infinite;
}
#bg8 {
    position: absolute;
    bottom: 0;
    right: 2%;
    height: 80%;
    animation-delay: 0.4s;
    animation: float-x-2 7s infinite;
}
#bg9 {
    position: absolute;
    top: 0;
    left: 0;
    animation: float-y-1 10s infinite;
}
#bg10 {
    position: absolute;
    bottom: 0;
    left: 0;
    animation-delay: 0.6s;
    animation: float-x-1 4s infinite;
}
#bg11 {
    position: absolute;
    bottom: 0;
    right: 0;
    animation-delay: 0.6s;
    animation: float-y-2 9s infinite;
}
#bg12 {
    position: absolute;
    top: 0;
    left: 40px;
    animation: float-y-1 5s infinite;
}
#bg13 {
    position: absolute;
    bottom: 0;
    left: 0;
    animation-delay: 0.6s;
    animation: float-x-1 4s infinite;
}
#bg14 {
    position: absolute;
    bottom: 30%;
    right: -10px;
    animation-delay: 0.6s;
    animation: float-x-2 9s infinite;
}

@media (max-width: 544px) {
  #bg5 {
    height: 100px;
  }
  #bg6, #bg7, #bg11, #bg12, #bg13 {
    display: none;
  }
  #bg8 {
    animation: float-y-2 7s infinite;
    height: 20%;
    right: 40%;
  }
  #bg9 {
    height: 150px;
    left: -50px;
    top: 60px;
  }
  #bg10 {
    height: 120px;
  }
  #bg14 {
    height: 170px;
    bottom: 5%;
    right: 0;
  }
}
@media (min-width: 544px) {
  #bg5 {
    height: 150px;
  }
  #bg7 {
    height: 250px;
  }
  #bg6 {
    display: none;
  }
  #bg8 {
    animation: float-y-2 7s infinite;
  }
  #bg9 {
    left: -170px;
  }
  #bg10 {
    height: 150px;
  }
  #bg11 {
    height: 300px;
    right: 0px;
  }
  #bg12, #bg13 {
    display: none;
  }
  #bg14 {
    height: 170px;
    bottom: 5%;
    right: 0;
  }
}
@media (min-width: 768px) {
  #bg6 {
    display: block;
  }
}
@media (min-width: 1100px) {
  #bg7 {
    display: block;
  }
  #bg9 {
    left: -60px;
  }
  #bg10 {
    height: 200px;
  }
  #bg11 {
    height: 400px;
    right: 0px;
  }
  #bg12, #bg13 {
    display: block;
    height: auto;
  }
  #bg14 {
    height: auto;
    bottom: 30%;
    right: -10px;
  }
}
@media (max-height: 700px) {
  #bg5, #bg7 {
    height: 140px;
  }
  #bg7, #bg10 {
    display: none;
  }
  #bg6 {
    height: 200px;
    top: auto;
    bottom: 0;
  }
}
.main-container {
  height: 100%;
  position: relative;
}
.dashboard {

}
.question-wrapper {
  margin: 0 auto;
  max-width: 500px;
  position: relative;
}
.send-progress {
  margin: 20px auto;
  width: 90px;
}
.progress-flex {
  display: flex;
  justify-content: space-between;
}
.progress-flex div {
  height: 10px;
  width: 10px;
  border: 1px solid #EC4F7F;
  background: transparent;
  border-radius: 10px;
}
.progress-flex div.active {
  background: #EC4F7F;
}
p.question {
  text-align: left;
  font-family: Kanit;
}
.boxed-input {
  margin-bottom: 20px;
}
.next-btn {
  color: #222;
  font-size: 28px;
  position: absolute;
  right: 0;
}
.next-btn:hover {
  font-weight: bold;
  text-decoration: none;
}
.next-btn::before {
  content: '';
  position: absolute;
  background: url('../assets/next.svg');
  background-repeat: no-repeat;
  background-size: 70px 5px;
  background-position: bottom;
  padding: 10px 0 15px 62px;
  bottom: 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
p {
  color: #222;
}
label {
  color: #fff !important;
}
#radio-btn-wrapper {
  margin-top: 20px;
}
.main-container {
  max-width: 1600px;
  margin: 0 auto;
}
p#message {
  padding: 15px;
  background-color: #572C3B !important;
  color: #fff;
}
.btn-flex {
  display: flex;
  margin-top: 40px;
}
#issue-form {
  max-width: 500px;
  margin: 0 auto;
  margin-top: -7px;
  margin-bottom: 100px;
  padding: 40px;
  display: none;
}
#note-issue {
  text-align: left;
  margin-top: -21px;
  font-size: smaller;
  color: rgba(0,0,0,0.5);
}
svg#svg-arrow {
  position: absolute;
  left: -134%;
  height: 120px;
  top: 700px;
}
p#arrow-text {
  color: #fff;
  font-weight: 600;
  position: absolute;
  left: -68%;
  width: 200px;
  font-size: 2em;
  top: 715px;
  line-height: 1.1em;
}

p.not-listed-btn {
  margin-bottom: 0px;
  margin-top: -10px;
  text-align: left !important;
  display: block;
}

p.not-listed-btn:hover {
  text-decoration: underline;
  cursor: pointer;
}

.v-autocomplete {
  position: relative;
}
.v-autocomplete .v-autocomplete-list {
  position: absolute;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
  cursor: pointer;
}

#yt-player {
  max-width: 500px !important;
}

#progress-circle {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 544px) {
  p.question {
    font-size: 28px;
    margin-bottom: 15px;
  }
  p.question:first-of-type {
    margin-top: 50px;
  }
  p.main-sub {
    max-width: 90%;
  }
  .start-btn {
    font-size: 20px;
  }
  .video-btn {
    margin-top: 2px;
  }
  svg#svg-arrow {
    display: none;
  }
  p#arrow-text {
    display: none;
  }
  #yt-player {
    width: 100%;
    height: auto;
    min-height: 190px;
  }
  .question-wrapper {
    padding-bottom: 60px;
  }
}
@media (min-width: 544px) {
  p.question {
    font-size: 30px;
  }
  p.main-sub {
    max-width: 85%;
  }
  .start-btn {
    font-size: 22px;
  }
  .video-btn {
    margin-top: 2px;
  }
  .question-wrapper {
    padding-bottom: 60px;
  }
}
@media (min-width: 768px) {
  p.question {
    font-size: 34px;
  }
  p.main-sub {
    max-width: 75%;
  }
  .start-btn {
    font-size: 24px;
  }
  .video-btn {
    margin-top: 4px;
  }
}
@media (min-width: 1024px) {
  p.question {
    font-size: 38px;
  }
  p.main-sub {
    max-width: 70%;
  }
  .start-btn {
    font-size: 26px;
  }
  .video-btn {
    margin-top: 5px;
  }
  .question-wrapper {
    padding-bottom: 0px;
  }
}
@media (min-width: 1200px) {
  p.question {
    font-size: 40px;
  }
  p.main-sub {
    max-width: 65%;
  }
  .start-btn {
    font-size: 28px;
  }
  .video-btn {
    margin-top: 6px;
  }
}
@media (min-width: 1440px) {
  p.question {
    font-size: 42px;
  }
  p.main-sub {
    max-width: 60%;
  }
  .start-btn {
    font-size: 32px;
  }
  .video-btn {
    margin-top: 7px;
  }
}
@media (max-height: 700px) {
  p.question {
    /* margin-top: 50px */
  }
}
@media (min-height: 1000px) {
  p.question:first-of-type {
    margin-top: 150px;
  }
}


</style>
